import { TipoTitolare } from "./global";

const { TITOLARE_UNICO, TITOLARE, NON_TITOLARE, NON_TITOLARE_PF } = TipoTitolare;

// ###################### STEP 2 ######################
// Presenta-azienda
export const tipoClienteOptions = [
	{ id: "PersonaGiuridica", label: "Società", value: "PersonaGiuridica" },
	{
		id: "PersonaFisica",
		label: "Ditta individuale o libero professionista",
		value: "PersonaFisica",
	},
];

// Presenta-azienda
export const tipoCodiceOptions = [
	{
		id: "piva",
		label: "Partita IVA",
		value: "PIVA",
	},
	{ id: "codiceFiscale", label: "Codice Fiscale", value: "CF" },
];

export const PersonalitaGiuridica = [
	{
		key: "",
		value: "",
	},
	{
		key: "Associazione",
		value: "Associazione",
	},
	{
		key: "Associazione In Partecipazione",
		value: "Associazione In Partecipazione",
	},
	{
		key: "Societa' Di Fatto",
		value: "Societa' Di Fatto",
	},
	{
		key: "Societa' In Accomandita Semplice",
		value: "Societa' In Accomandita Semplice",
	},
	{
		key: "Societa' In Nome Collettivo",
		value: "Societa' In Nome Collettivo",
	},
	{
		key: "Societa' Semplice",
		value: "Societa' Semplice",
	},
	{
		key: "Azienda Municipale",
		value: "Azienda Municipale",
	},
	{
		key: "Azienda Provinciale",
		value: "Azienda Provinciale",
	},
	{
		key: "Azienda Regionale",
		value: "Azienda Regionale",
	},
	{
		key: "Ente Diritto Pubblico",
		value: "Ente Diritto Pubblico",
	},
	{
		key: "Ente Pubblico Economico",
		value: "Ente Pubblico Economico",
	},
	{
		key: "Istituto Di Credito",
		value: "Istituto Di Credito",
	},
	{
		key: "Societa' Per Azioni Con Socio Unico",
		value: "Societa' Per Azioni Con Socio Unico",
	},
	{
		key: "Societa' A Responsabilita' Limitata",
		value: "Societa' A Responsabilita' Limitata",
	},
	{
		key: "Societa' A Responsabilita' Limitata A Capitale Ridotto",
		value: "Societa' A Responsabilita' Limitata A Capitale Ridotto",
	},
	{
		key: "Societa' A Responsabilita' Limitata Con Unico Socio",
		value: "Societa' A Responsabilita' Limitata Con Unico Socio",
	},
	{
		key: "Societa' A Responsabilita' Limitata Semplificata",
		value: "Societa' A Responsabilita' Limitata Semplificata",
	},
	{
		key: "Societa' In Accomandita Per Azioni",
		value: "Societa' In Accomandita Per Azioni",
	},
	{
		key: "Societa' Per Azioni",
		value: "Societa' Per Azioni",
	},
	{
		key: "Impresa Familiare",
		value: "Impresa Familiare",
	},
	{
		key: "Impresa Individuale",
		value: "Impresa Individuale",
	},
	{
		key: "Ente",
		value: "Ente",
	},
	{
		key: "Ente Ecclesiastico",
		value: "Ente Ecclesiastico",
	},
	{
		key: "Fondazione",
		value: "Fondazione",
	},
	{
		key: "Cooperativa Sociale",
		value: "Cooperativa Sociale",
	},
	{
		key: "Consorzio",
		value: "Consorzio",
	},
	{
		key: "Societa' Di Mutuo Soccorso",
		value: "Societa' Di Mutuo Soccorso",
	},
	{
		key: "Societa' Consortile",
		value: "Societa' Consortile",
	},
	{
		key: "Societa' Cooperativa",
		value: "Societa' Cooperativa",
	},
	{
		key: "Societa' Con Altra Forma Giuridica",
		value: "Societa' Con Altra Forma Giuridica",
	},
];

// Bilancio impresa
export const risultatoEconomicoOptions = [
	{ id: "utile", label: "Utile", value: "utile" },
	{ id: "perdita", label: "Perdita", value: "perdita" },
];

// Bilancio impresa
export const volumeAffariOptions = [
	{ id: "<500.000", label: "Fino a 500.000€", value: "volume1" },
	{
		id: "500.000-2.000.000",
		label: "Da 500.000€ a 2.000.000€",
		value: "volume2",
	},
	{ id: ">2.000.000", label: "Oltre 2.000.000€", value: "volume3" },
];

// Dettagli-società
export const tipologiaAttivitaOptions = [
	{
		id: "imprenditoriale",
		label: "Attività imprenditoriale",
		value: "imprenditoriale",
	},
	{
		id: "liberaConIscrizone",
		label: "Libera professione con iscrizione ad albi/ordini professionali",
		value: "liberaConIscrizone",
	},
	{
		id: "liberaSenzaIscrizone",
		label: "Libera professione senza iscrizione ad albi/ordini professionali",
		value: "liberaSenzaIscrizone",
	},
	{ id: "noProfit", label: "Attività No Profit", value: "noProfit" },
	{ id: "altro", label: "Altro", value: "altro" },
];

// Dettagli-società
export const areaGeograficaOptions = [
	{ id: "italia", label: "Solo l'Italia", value: "italia" },
	{ id: "ue", label: "Area UE", value: "ue" },
	{ id: "extraUe", label: "Area extra-UE", value: "extraUe" },
];
// ###################### FINE STEP 2 ######################
// ###################### STEP 3 ######################
// Anagrafica
export const genereOptions = [
	{ id: "maschio", label: "Maschio", value: "M" },
	{ id: "femmina", label: "Femmina", value: "F" },
];

// Cariche-pubbliche
export const titolareEffettivoOptions = [
	{
		id: "1",
		label: "Di essere l'unico titolare effettivo",
		value: TITOLARE_UNICO,
	},
	{
		id: "2",
		label: "Di essere titolare effettivo unitamente ad altre persone",
		value: TITOLARE,
	},
	{
		id: "3",
		label:
			"Di non essere titolare effettivo, ma che il/i titolare/i effettivo/i è/sono un'altra/altre persona/e",
		value: NON_TITOLARE,
	},
	{
		id: "4",
		label:
			"Di non essere titolare effettivo, ma che ci sono persone fisiche che esercitano in altro modo poteri di amministrazione / direzione sul punto operativo",
		value: NON_TITOLARE_PF,
	},
];

// Cariche-pubbliche
export const condanneOptions = [
	{
		id: "1",
		label:
			"Dichiaro di 𝗡𝗢𝗡 𝗔𝗩𝗘𝗥 riportato condanne penali e di non essere destinatario di provvedimenti che riguardano l’applicazione di misure di prevenzione o cautelari, di decisioni civili e di provvedimenti amministrativi iscritti nel casellario giudiziale ai sensi della vigente normativa, nonché di non sapere di essere sottoposto a procedimenti penali.",
		value: false,
	},
	{
		id: "2",
		label:
			"Dichiaro di 𝗔𝗩𝗘𝗥 riportato condanne penali e di essere destinatario di provvedimenti che riguardano l’applicazione di misure di prevenzione o cautelari, di decisioni civili e di provvedimenti amministrativi iscritti nel casellario giudiziale ai sensi della vigente normativa.",
		value: true,
	},
];
// ###################### FINE STEP 3 ######################
